export const STAFF_LIST_MOCKUP_DATA = [
  {
    id: "c98fe615-0321-4c7e-b7cf-eb9526b5bfb3",
    staffId: "1aac82c9-b632-4f4f-924f-73af99e3ccfa",
    name: "Clint Howen",
    status: 1,
  },
];
